<template>
<div class="login-outbox">
	<div class="header-box">
		<div class="header-inner" :style="{'background': getBackground,'background-size': 'auto 38px'}">
			<h1></h1>
		</div>
	</div>
	<div class="logbox">
		<div class="login" id="login">
			<div class="loginLeft">
			</div>
		    <div class="log-email position-relative">
		    	<h3>
		    		使用注册账号登录
		    	</h3>
		    	<p class="log_warn" v-text="logWarn" v-if="isWarn"></p>            
		        <input type="text" placeholder="请输入用户名" :class="'log-input' + (account==''?' log-input-empty':'')" v-model="account">
		        <input type="password" placeholder="请输入密码" :class="'log-input' + (password==''?' log-input-empty':'')"  v-model="password">
		        <a href="javascript:;" class="log-btn" @click="login">登录</a>
		        <router-link class="text1" to="/findpass">忘记密码</router-link>
		        <router-link class="text2" to="/register">免费注册→</router-link>
		    </div>
		</div>
	</div>
	<!-- <p class="copyright">
		Copyright © 2004-2019  landesker 版权所有<a class="link" target="_blank" href="http://www.gdatacenter.com"> 蓝代斯克官网 </a>
	</p> -->
</div>
</template>

<script>
let sha256=require("js-sha256").sha256;
export default {
  name: 'Login',
  data() {
  	return {
      isWarn:false,
      logWarn:'',
  		account: '',
  		password: ''
  	}
  },
  computed:{
	  getBackground(){
		 return 'url('+this.$store.state.domain3+'logo3.png) #133169 no-repeat 25px'
	 },
  },
  methods:{

  	//登录逻辑
  	login(){
  		this.isWarn = false;
		this.logWarn = '';
  		if(this.account!='' && this.password!=''){
  			this.toLogin();
  		}else{
        	this.isWarn = true;
            this.logWarn = "用户名和密码都不能为空";
  		}
  	},

  	//登录请求
  	toLogin(){
  		this.isWarn = false;
		this.logWarn = '';
		var reg=11 && /^(1\d{10})$/;
		
		if(!reg.test(this.account)){
			this.isWarn = true;
			this.logWarn = '请输入正确的手机号码';
		}
		else{
			let password_sha = sha256( this.password );
	  		//登录接口请求参数
	  		let loginRequestParams = this.$qs.stringify({
	  			username: this.account,
	              password:password_sha,
	              terminalId:4
	  		});
	        let that=this;
	  		this.$ajax.post(this.$store.state.domain+'/Home/Login/login',loginRequestParams,{
	            emulateJSON: true
	        }).then((response) => {
	            let respBody = response.data;
	            if(respBody.status == 1){
	                var respData = respBody.data||null;
	                /*console.log(respData);*/
	                if(respData!==null){
	                    let expireDays = 1000 * 60 * 60 * 24 * 15;
	                    /*机房去除弱电间再存cookie*/
	                    that.setCookie('uid',respData.uid,expireDays);
	                    that.setCookie('real_name',respData.real_name,expireDays);
	                    that.setCookie('username',respData.username,expireDays);
	                    that.setCookie('administrators',respData.administrators,expireDays);
	                    that.setCookie('token', respData.token, expireDays);
	                    that.setCookie('company_id', respData.company_id, expireDays);
	            //   alert('登录成功：'+respData.token);
	            		let userInfo= { //保存用户信息
					        real_name: respData.real_name,
					        administrators: respData.administrators,
					        username: respData.username,
					        token:respData.token,
					        uid:respData.uid,
					        company_id:respData.company_id,
					    }
	            		
	            
	            //登录成功后
	            
	             //提交mutation到Store
	      			this.$store.commit('updateUserInfo', userInfo); 
	      				that.$router.push('/alarmStatistical'); 
	                    
	                    /*console.log(that.getCookie('uid'));*/
	                }
	            }else{
	            	this.isWarn = true;
	            	//console.log(respBody.msg);
	                this.logWarn = respBody.msg;
	            }
		    }, (response) => {
	            console.log('http request error!');
	            console.log(response);
		        //Error
		    });
		}
  		
  	}
  }
}
</script>

<style scoped="scoped">
	
.log_warn{
	position: absolute;
	top: 100px;
	left: 5px;
}
</style>



// WEBPACK FOOTER //
// src/components/Login.vue